var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dim flex-col"},[_c('div',{staticClass:"safe-area absolute"},[_c('div',{staticClass:"popup-wrap"},[_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])]),_c('div',{staticClass:"button-wrap"},[_c('button',{staticClass:"button-bg-gray",on:{"click":_vm.closeEvent}},[_vm._v("닫기")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }